import React from 'react';

import Icon from './Icon';

const Quote = ({ className }) => (
  <Icon name="quote" className={className} viewBox="0 0 24 24">
    <g stroke="none" strokeWidth="1" fillRule="evenodd">
      <g transform="translate(-231.000000, -750.000000)">
        <path d="M241.795455,750 C235.826203,750 231,754.634146 231,760.365854 C231,766.097561 235.826203,770.731707 241.795455,770.731707 L242.430481,770.731707 L242.430481,775 C248.653743,772.195122 252.590909,765.853659 252.590909,760.365854 C252.590909,754.634146 247.764706,750 241.795455,750 L241.795455,750 Z M241.227273,761.363636 L240.090909,763.636364 L238.386364,763.636364 L239.522727,761.363636 L237.818182,761.363636 L237.818182,757.954545 L241.227273,757.954545 L241.227273,761.363636 L241.227273,761.363636 Z M245.772727,761.363636 L244.636364,763.636364 L242.931818,763.636364 L244.068182,761.363636 L242.363636,761.363636 L242.363636,757.954545 L245.772727,757.954545 L245.772727,761.363636 L245.772727,761.363636 Z"></path>
      </g>
    </g>
  </Icon>
);

// peppe
export default Quote;
